import React from 'react';
import PropTypes from 'prop-types';

import {Field, reduxForm} from 'redux-form';
import FieldCheckbox from '../fields/fieldCheckbox/FieldCheckbox';
import Button from '../button/Button';
import {FormattedMessage} from 'react-intl';

@reduxForm({
  form: 'oAuthTOS',
  validate: ({tosAccepted}) => ({
    tosAccepted: tosAccepted ? undefined : <FormattedMessage id="section.auth.accept-tos"/>
  })
})
export default class OAuthTOSForm extends React.PureComponent {
  render() {
    const {handleSubmit, submitting, error} = this.props;

    return (
      <form className="form" onSubmit={handleSubmit}>
        {error && <span className="form__error">{error}</span>}

        <Field
          name="tosAccepted"
          component={FieldCheckbox}
        >
          <FormattedMessage id="section.tos.agree"/>
          {' '}
          <a href="/page/terms-of-service" target="_blank">
            <FormattedMessage id="section.tos.terms"/>
          </a>
          {' '}
          <FormattedMessage id="section.tos.and"/>
          {' '}
          <a href="/page/privacy-policy" target="_blank">
            <FormattedMessage id="section.tos.privacy-policy"/>
          </a>
        </Field>

        <Field
          name="newsletterSubscribed"
          component={FieldCheckbox}
        >
          <FormattedMessage id="section.subscribe"/>
        </Field>

        <Button full filled loading={submitting} disabled={submitting}>
          <FormattedMessage id="section.auth.sign-up.action"/>
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/auth/OAuthTOSForm.js